import React, { useEffect, useState } from 'react';
import HelpBackIcon from './../../../../../images/helpbackicon.png'
import {Link, useNavigate} from 'react-router-dom'

function SocialMedia() { 
    const [feedback,setFeedback] = useState(false)
    const navigate= useNavigate();

    return (
        <div style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/yovww6fxrbmtzfqlpy0z")`,backgroundPositionX:'-1em',backgroundSize:'100%'}}>

        <div style={{         
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        zIndex:'1',
        height:'9.63em'
        }}/>

        <div style={{
              backgroundColor:'#F9FCFF',
              width:'100%',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              paddingBottom:'5.5em',
              minHeight: '72vh', height: 'auto'
        }}>
            <div style={{
                display:'flex',
                flexDirection:'column',
                alignItems:'flex-start',
                width:'70%',
                paddingTop:'2.5em'
            }}>

                <div style={{
                    display:'flex',
                    flexDirection:'row',
                    alignItems:'center',
                    cursor:'pointer'
                   
                }} onClick={()=>{navigate("/help");setFeedback(false)}}>
                    <img src={HelpBackIcon} style={{width:'1.5em',height:'1.5em',marginRight:'0.25em',cursor:'pointer'}}/>
                    <div className="backTxt">Back</div>
                </div>

                <div className="infoHeader">
                Social Media Integrations
                </div>

                <div className="infoDescHeader" style={{marginTop:'0em'}}>
                CONNECT YOUR SOCIALS
                </div>

                <div className="infoDesc">
                The Social Media Integration feature on your dashboard enables you to seamlessly integrate your social media accounts to your profile. By linking platforms like Instagram, Facebook, Twitter, and more, you can streamline your promotional efforts, automatically share updates, and engage with your audience across multiple channels from one central hub. This feature allows you to sync your content, track your social media performance, and manage your online presence more efficiently. It's an essential tool for amplifying your reach and keeping your fans connected to your latest releases and activities.
                </div>

                <div className="infoDesc">
                <br/>To integrate your social media pages, go to your home page in the dashboard and click “Connect My Account” in the Get To Know Your Fans section of the news feed.
                </div>


                {
                    !feedback &&
                    <div>
                         <div className="infoDesc" style={{marginTop:'6.5em'}}>
                            Was this article helpful?
                            </div>

                            <div style={{display:'flex',flexDirection:'row'}}>
                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    YES
                                </div>

                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    NO
                                </div>
                            </div>
                    </div>
                }

                {
                    feedback &&
                    
                         <div className="infoDesc" style={{marginTop:'8.5em'}}>
                           Thank you for your feedback
                            </div>

                         
                    
                }
               
            </div>

        </div>
        
        
       
    </div>
    )
}


export default SocialMedia;